import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0d6a4488&scoped=true&functional=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=0d6a4488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0d6a4488",
  null
  
)

export default component.exports